import React from 'react';
import './style.scss';
import { identity } from "../../../utils/getIdentity";

const Card = ({ children }) => {
  return <div className={`admin-card admin-card-${identity}`}>{children}</div>;
};

export default Card;
